// extracted by css-extract-rspack-plugin
export default {"chartWithActions":"jdkJ6cYWenAhQDeW","actions":"A652vCUVL1Yv8MmX"};